import { atom } from 'jotai'

export const draggingVehicleAtom = atom<boolean>(false)

draggingVehicleAtom.debugLabel = 'draggingVehicleAtom'
